// frontend/src/pages/dashboard/ProjectComponents/ImagePreview.js
import React, { useState, useEffect } from 'react';
import { Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AttachFileIcon from '@mui/icons-material/AttachFile';

const ImagePreview = ({ file, onRemove, index }) => {
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => {
    if (file && file.type.startsWith("image/")) {
      const url = URL.createObjectURL(file);
      setPreviewUrl(url);
      return () => URL.revokeObjectURL(url);
    }
  }, [file]);

  if (!file) return null;

  return (
    <Box
      sx={{
        position: "relative",
        width: 100,
        height: 100,
        borderRadius: 2,
        overflow: "hidden",
        border: "1px solid #e0e0e0",
        "&:hover .remove-btn": { opacity: 1 },
      }}
    >
      {file.type.startsWith("image/") ? (
        <img
          src={previewUrl || URL.createObjectURL(file)}
          alt={file.name}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      ) : (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "#f5f5f5",
          }}
        >
          <AttachFileIcon color="action" />
        </Box>
      )}
      {onRemove && (
        <IconButton
          className="remove-btn"
          size="small"
          onClick={() => onRemove(index)}
          sx={{
            position: "absolute",
            top: 4,
            right: 4,
            bgcolor: "rgba(255, 255, 255, 0.9)",
            width: 24,
            height: 24,
            opacity: 0,
            transition: "opacity 0.2s",
            "&:hover": { bgcolor: "rgba(255, 0, 0, 0.8)", color: "#fff" },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
};

export default ImagePreview;